export const navigateWithFilters = (history, path, filters, filterLabels) => {
  history.push(path, { initialFilters: filters, initialFilterLabels: filterLabels });
};
